import React, { FunctionComponent, useEffect } from 'react';

import { MODAL } from '../../context';
import { useApp } from '../../hooks';
import Modal from '../Modal/Modal';
import { EncourageShareModal } from './EncourageShareModal';

export const EncourageShareModalContainer: FunctionComponent = () => {
  const { hideModal, showModal, openModal } = useApp();
  const storageKey = 'isEncourageSharePromptDismissed';
  const closeModal = () => {
    localStorage.setItem(storageKey, String(true));
    hideModal();
  };

  useEffect(() => {
    const userHasDismissed = localStorage.getItem(storageKey) === String(true);

    if (userHasDismissed) {
      return;
    }

    const timer = global.setTimeout(() => {
      showModal(MODAL.ENCOURAGE_SHARE);
    }, 40000);

    return () => clearTimeout(timer);
  }, [showModal]);

  return (
    <>
      {openModal === MODAL.ENCOURAGE_SHARE && (
        <Modal onCloseRequest={closeModal}>
          <EncourageShareModal onClose={closeModal} />
        </Modal>
      )}
    </>
  );
};
